<template>
  <v-card class="overflow-y-auto" tile flat>
    <v-container class="pt-4 pb-4" style="width:90%;">
      <v-expansion-panels v-model="project_noticeOpen" v-if="((aboutpj&&aboutpj.notice)||isAdmin||true)" class="mb-6">
        <v-expansion-panel>
          <v-expansion-panel-header style="color:#2b2b2b;" color="#B6E3BA">
            <p class="text-left mb-0">お知らせ</p>
            <p class="text-right mb-0" style="font-size:8px"><span v-if="project_noticeOpen===0">閉じる</span><span v-else>詳細の表示</span></p>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pa-2" color="#B6E3BA">
            <p v-text="aboutpj.notice" v-if="aboutpj&&aboutpj.notice&&aboutpj.notice.length>0"></p>
            <p v-else class="text-center" style="color:#707070;">お知らせはまだ登録されていません。</p>
            <v-textarea
              v-if="editNotice"
              v-model="noticeContent"
              outlined
              name="input-7-4"
              label=""
              value=""
            ></v-textarea>
            <div class="d-flex" v-if="isAdmin">
              <v-btn color="#399942" class="rounded-pill ml-auto" dark @click="(editNotice=true,noticeContent=aboutpj.notice)" v-if="!editNotice"><v-icon color="white">mdi-cog</v-icon>編集</v-btn>
              <v-btn class="rounded-pill ml-auto" @click="(editNotice=false)" v-if="editNotice">キャンセル</v-btn>
              <v-btn color="#399942" class="rounded-pill ml-4 mr-auto px-8" dark @click="submitNotice()" v-if="editNotice">登録</v-btn>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-expansion-panels style="border-radius: 5px;" v-model="project_aboutt">
        <v-expansion-panel>
          <v-expansion-panel-header style="color:#2b2b2b;" class="shallowCloud">
            <p class="text-left mb-0">{{$t('プロジェクト')}}概要</p>
            <p class="text-right mb-0" style="font-size:8px"><span v-if="project_aboutt===0">閉じる</span><span v-else>詳細の表示</span></p>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="shallowCloud pa-2">  
            <div v-if="false">
              <p class="abyss--text mb-0 pa-2">投票開始予定日時</p>
              <p class="text-subtitle-2 ml-6 mb-0"><span class="text-h6" style="color:#E64550">2022</span>年<span class="text-h6" style="color:#E64550">12</span>月<span class="text-h6" style="color:#E64550">31</span>日 <span class="text-h6" style="color:#E64550">13</span>時<span class="text-h6" style="color:#E64550">00</span>分</p>
              <p class="ml-6 mb-0" style="color:#2B2B2B">あとn日</p>          
            </div>

            <div class="d-flex">
              <div>
                <p class="abyss--text mb-0 pa-2">タイトル</p>
                <p class="ml-6" v-if="aboutpj&&aboutpj.title">{{aboutpj.title}}</p>
              </div>
              <v-btn color="#399942" class="rounded-pill ml-auto" dark @click="$emit('pjSetting')" v-if="$mq==='pc'&&((pjadmins&&pjadmins.some((el) => el === uid)&&(aboutpj.condition=='dis'))||(isAdmin&&isAuthed&&aboutLid&&aboutLid.sanka&&aboutpj.sanka))"><v-icon color="white">mdi-cog</v-icon>設定</v-btn>
            </div>

            <div class="d-flex justify-space-between">
              <div>
                <p class="abyss--text mb-0 pa-2">担当課</p>
                <p class="ml-6" v-if="aboutpj&&aboutpj.inCharge">{{aboutpj.inCharge}}</p>
                <p class="ml-6" style="color:#2B2B2B; font-size:14px;" v-else>まだ担当課が設定されていません。</p>
              </div>
            </div>

            <div>
              <v-card-actions>
                <p class="abyss--text mb-0">概要</p>
                <v-spacer></v-spacer>
              </v-card-actions>
              <p class="ml-6" v-if="aboutpj" v-dompurify-html="aboutpj.summary"></p>          
            </div>

            <div>
            <p class="abyss--text mb-0 pa-2">関連リンク</p>
            <v-card-text class="ml-2" v-if="aboutpj.links&&aboutpj.links.length>0">
              <v-list-item v-for="(link, i) in aboutpj.links" :key="i">
                <v-list-item-content class="py-0 my-0">
                  <v-list-item-title>
                    <p v-if="link.title"><a :href="`${link.url}`" target="_blank" rel="noopener noreferrer"
                    >{{link.title}}</a></p>
                    <p v-else><a :href="`${link.url}`" target="_blank" rel="noopener noreferrer"
                    >{{`${link.url}`}}</a></p>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
            <v-card-text class="ml-3" v-else>
              関連URLは登録されていません
            </v-card-text>
            </div>
            
            <div>
              <v-card-actions>
                <p class="abyss--text mb-0">{{$t('プロジェクト')}}の管理者  <span class="text-h6" v-if="aboutpj" v-text="pjadmins.length"></span><span class="text-caption">人</span></p>
                <v-spacer></v-spacer>
                <v-btn class="ma-0 rounded-pill deepAlgae" dark v-if="$mq==='pc'&&((pjadmins&&pjadmins.some((el) => el === uid))||(isAdmin&&isAdmin&&isAuthed&&aboutLid&&aboutLid.sanka&&aboutpj.sanka))" @click="lidAdmview=true">
                  <v-icon color="white">mdi-cog</v-icon>管理者を編集する
                </v-btn>
              </v-card-actions>
              <v-card-actions class="pt-0" v-if="pjadmins.length>0">
                <v-btn elevation="3" class="px-4 white rounded-pill" outlined @click="profileUid = pjadmins[0],profile = true">
                  <v-avatar size="30">
                    <img v-bind:src="profImageDict[pjadmins[0]]">
                  </v-avatar>
                  <span class="" style="font-size:12px;" v-if="pjadmins" v-text="namelist[pjadmins[0]]"></span>
                </v-btn>
                <v-btn text color="#008CFF" class="pt-2" v-if="pjadmins&&pjadmins.length>1" @click="lidAdmview=true">
                  <span class="text-caption" style="text-decoration: underline;">他<span class="text-caption" v-if="aboutpj" v-text="minusone(pjadmins.length)"></span>人について確認する</span>
                </v-btn>
              </v-card-actions>          
            </div>

            <div class="d-flex align-center">
              <p class="abyss--text mb-0 pa-2">採用された{{$t('アイデア')}}</p>
              <v-spacer></v-spacer>
              <v-btn class="ma-4 rounded-pill" @click="getIdea(),checkIdea = true" color="#008CFF" dark>{{$t('アイデア')}}を見る</v-btn>        
            </div>
            <!--フッター-->
            <p class="abyss--text mb-0 pa-2" v-if="$mq==='pc'&&(($mq==='pc'&&pjadmins&&pjadmins.includes(uid))||(isAdmin&&isAuthed))">管理者設定</p>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="rounded-pill deepAlgae white--text" @click="redis = true" v-if="aboutpj&&aboutpj.condition&&aboutpj.condition!=='dis'&&(($mq==='pc'&&pjadmins&&pjadmins.includes(uid))||(isAdmin&&isAuthed))">再議論</v-btn>
              <v-btn class="rounded-pill lava white--text" @click="$emit('voteStart')" v-if="$mq==='pc'&&aboutpj&&aboutpj.condition&&aboutpj.condition==='dis'&&(($mq==='pc'&&pjadmins&&pjadmins.includes(uid))||(isAdmin&&isAuthed))">投票開始</v-btn>
              <v-btn class="rounded-pill lava white--text" @click="confirmVoteEnd=true" v-if="$mq==='pc'&&aboutpj&&aboutpj.condition&&aboutpj.condition==='voting'&&(($mq==='pc'&&pjadmins&&pjadmins.includes(uid))||(isAdmin&&isAuthed))">投票終了</v-btn>
              <v-btn class="rounded-pill deepLava white--text" @click="ProFinCheck=true" v-if="($mq==='pc'&&pjadmins&&pjadmins.includes(uid))||(isAdmin&&isAuthed)">{{$t('プロジェクト')}}終了</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
            <v-card-actions v-if="false">
              <v-spacer></v-spacer>
              <v-btn class="rounded-pill" data-testid="gotoProFinCheck" v-if="(isAdmin&&isAuthed)" @click="$emit('outPj')" color="#E64550" dark>退出</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>

    <!--アイデア一覧-->
    <v-dialog v-model="checkIdea" :fullscreen="$mq==='sp'" class="z1000">
      <v-card flat>
        <v-card-actions>
          <v-spacer></v-spacer>
          <h2 class="text-center">採用された{{$t('アイデア')}}</h2>
          <v-spacer></v-spacer>
          <v-icon x-large @click="checkIdea = false">mdi-close</v-icon>
        </v-card-actions>
        <p class="text-center" style="color:#BA0009"><span v-if="selectedIdea" v-text="selectedIdea.length"></span>件の{{$t('アイデア')}}を採用中</p>
        <v-container style="max-height: 100%" class="overflow-y-auto">
          <v-row>
          <v-col v-for="ide in selectedIdea" :key="ide.sort" cols="12" sm="4">
            <v-card class="mx-auto ma-0 pa-2 d-flex flex-column" outlined elevation="0" height="250" style="border-width: 1.5px; border-color: #707070;">
              <!--ideaヘッダー-->
              <v-card-actions class="pa-0">
                <!--ideaタグ-->
                <v-chip v-if="ide.tag&&ide.tag.title&&aboutLid&&aboutLid.tags&&aboutLid.tags.title&&aboutLid.tags.title.includes(ide.tag.title)" color="#dcdcdc"><v-icon :color="ide.tag.color" size="20">mdi-checkbox-blank-circle</v-icon><p class="mb-0" style="font-size:14px;">&nbsp;{{ ide.tag.title }}</p></v-chip>
                <v-spacer></v-spacer>
                <v-icon v-if="ide.latlngInputLat!=0||false" color="rgba(135,206,250,0.5)" size="30">mdi-map</v-icon>
                <!--idea編集・削除-->
              </v-card-actions>
              <!--idea本文-->
              <v-card-actions color="#2B2B2B" class="d-flex flex-column overflow-y-auto my-0 pt-0 text-left" style="height:70%;" :style="{ 'font-size': ideaFontSize }">
                <p class="mb-0 text-left" style="width:100%;">{{ide.content}}<span class="font-weight-700" style="font-size:10px;" v-if="ide.edit">(編集済み)</span></p>
                <div v-if="ide.quotingId" style="width: 100%;">
                  <QuoteBlock :idea="(idea.find(el => el.id === ide.quotingId))" :namelist="namelist" ></QuoteBlock>
                </div>
              </v-card-actions>
              <!--idea画像-->
              <v-img v-if="ide.ideaImage && ide.ideaImage_large" contain max-width="100px" max-height="55px"
                :src="ide.ideaImage" @click.native="images=true,dialog_image=ide.ideaImage_large" alt="" class="mx-auto">
              </v-img> 
              <v-img v-else-if="ide.ideaImage" contain max-width="100px" max-height="55px"
                :src="ide.ideaImage" @click.native="images=true,dialog_image=ide.ideaImage" alt="" class="mx-auto">
              </v-img>
              <!--ideaフッター-->
              <v-card-actions class="d-flex pa-0 mt-auto">
                <!--idea位置情報-->
                <div v-if="ide.placename">
                  <p class="mb-0"><v-icon color="#707070" size="25">mdi-map-marker</v-icon>{{ide.placename}}</p>
                </div>
                <!--idea時間-->
                <div v-if="timeday !== ide.timeday" class="ml-auto">
                  <p class="mb-0" style="color:#2B2B2B !important;">{{ide.timeday}}</p>
                </div>
                <div v-else class="ml-auto">
                  <p class="mb-0" style="color:#2B2B2B !important;">{{ide.timehour}}</p>
                </div>
              </v-card-actions>
              <v-card-actions class="d-flex justify-space-between pa-0">
                <!--idea作者-->
                <div>
                  <div v-if="ide.anonymous||namelist[ide.author]==undefined||namelist[ide.author]==null" style="color:#2B2B2B !important;" class="d-flex">
                    <!-- <v-btn small icon @click="profileUid = ide.author,profile = true"> -->
                    <v-icon size="25" style="color:rgba(128,128,128,0.4)!important;">mdi-account-circle</v-icon>
                    匿名
                  </div>
                  <div v-else-if="profImageDict[ide.author]==undefined && ide.anonymous!=true" style="color:#2B2B2B !important;" class="d-flex">
                    <v-btn height="25px" icon @click="profileUid = ide.author,profile = true">
                      <v-icon size="25" style="color:rgba(128,128,128,0.4)!important;">mdi-account-circle</v-icon>
                      {{namelist[ide.author]}}
                    </v-btn>
                  </div>
                  <div v-else-if="profImageDict[ide.author]!=undefined && ide.anonymous!=true" style="color:#2B2B2B !important;" class="d-flex">
                    <!-- <v-icon size="25" style="color:rgba(128,128,128,0.4)!important;">mdi-account-circle</v-icon> -->
                    <v-btn height="25px" icon @click="profileUid = ide.author,profile = true">
                      <v-avatar size="25">
                        <img v-bind:src="profImageDict[ide.author]">
                      </v-avatar>
                    </v-btn>
                    {{namelist[ide.author]}}
                  </div>
                </div>
                <!--ideaいいね-->
                <div v-if="ide.like&&ide.like.length>=0" class="ma-0">
                  <template>
                    <v-btn class="ma-0 rounded-pill" elevation="0"  height="25" width="auto" v-on:click="likecomment(ide.id)" :disabled="true">
                      <v-icon size="25"  :color="ide.like.includes(uid) ? 'shallowAqua' : 'shallowCloud'">mdi-thumb-up</v-icon>
                      <v-card-text v-if="uid === ide.author || aideauids.some(el => el === ide.id) || aboutLid.lidAdmin.includes(uid) || isAdmin" class="pa-0">
                        <span style="color:#008CFF" v-text="ide.like.length" v-if="ide.like.includes(uid)"></span>
                        <span class="cloud--text" v-text="ide.like.length" v-else></span>
                      </v-card-text>
                      <v-card-text v-else-if="((ide.like.includes(uid) == false && ide.like.length > 0) || ide.like.length > 1 ) && uid != ide.author" class="pa-0 text-right" style="font-size:10px;">
                        <span v-if="ide.like.includes(uid)"  style="color:#008CFF;">いいね有</span>
                        <span v-else  style="color:#707070;">いいね有</span>
                      </v-card-text>
                    </v-btn>
                  </template>
                </div>
              </v-card-actions>
            </v-card> 
          </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <!--Lid管理者画面-->
    <v-dialog
      v-model="lidAdmview"
      :fullscreen="$mq==='sp'"
      persistent 
      @keydown.esc="lidAdmview = false"
      class="z1000"
    >
      <listAdm :lidId="$route.params.id" :lidTitle="aboutpj.title" :pjId="pjuid" :pjadmins="pjadmins" mode="pj" @listAdmClose="oneaddAdmin"></listAdm>
    </v-dialog>

    <!--投票終了確認画面-->
    <v-dialog v-model="confirmVoteEnd" width="60%" class="z1000">
      <v-card class="pa-4">
        <v-card-text class="text-center pt-8 px-8 py-2 text-h5 font-weight-bold" style="color:#0F0101;">
          <v-img class="dog" max-height="100%" max-width="8%" src="../../assets/svg/5007red.svg"></v-img>
          投票を締め切りますか？
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-chip class="mt-4 mx-2 px-4" color="#66baff" @click="confirmVoteEnd=false, $emit('voteFinish')" dark>はい</v-chip>
          <v-chip class="mt-4 mx-2 px-4" color="#E64550" @click="confirmVoteEnd=false" dark> いいえ</v-chip>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--プロジェクト終了-->
    <!--再議論確認画面-->
    <v-dialog v-model="redis" width="60%" class="z1000">
      <v-card color="white" elevation="15" class="pt-6">
        <p class="font-weight-bold pt-6 px-8 text-h5 text-center">
          この{{$t('プロジェクト')}}について再議論しますか？
        </p>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-chip class="ma-4 pa-4 font-weight-bold" @click="redis = false">再議論しない</v-chip>
          <v-chip class="ma-4 pa-4 font-weight-bold" @click="redis = false, rePj()" color="#66baff" dark>再議論する</v-chip>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--再議論移行-->
    <v-dialog v-model="noticeRedis" width="60%" class="z1000">
      <v-card class="py-6">
        <v-card-text class="text-center px-8 py-2 text-h6 font-weight-bold" style="color:#2B2B2B;">この{{$t('プロジェクト')}}は議論フェーズに移行されました</v-card-text>
        <v-card-text class="text-center px-8 py-2 text-h6 font-weight-bold" style="color:#2B2B2B;">ページを再読み込みします</v-card-text>
        <v-card-actions class="py-0 my-0">
          <v-spacer></v-spacer>
          <v-chip class="my-2 font-weight-bold deepAqua" @click="noticeRedis = false, reload()" dark>確認</v-chip>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--プロジェクト終了確認画面-->
    <v-dialog v-model="ProFinCheck" width="60%" class="z1000">
      <v-card class="pa-4">
        <p class="text-center pt-8 ma-2 pa-2 font-weight-bold text-h5">
          {{$t('プロジェクト')}}を終了しますか？
        </p>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-chip class="ma-4 pa-4" @click="ProFinCheck=false">終了しない</v-chip>
          <v-chip class="ma-4 pa-4 deepLava" @click="removePj=true" dark>終了する</v-chip>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--プロジェクト終了理由画面-->
    <v-dialog v-model="removePj" height="80%" width="60%" class="z1000">
      <v-card class="pa-2" style="overflow:hidden">
        <v-card-actions>
          <h3 class="mb-0">{{$t('プロジェクト')}}を削除</h3>
          <v-spacer></v-spacer>
          <v-btn x-large @click="removePj=false" icon><v-icon x-large>mdi-close</v-icon></v-btn>          
        </v-card-actions>
        <v-textarea
          outlined
          class="px-10 pt-2"
          filled
          background-color="white"
          label="削除理由"
          auto-grow
          v-model="removeReason"
          height="260px"
        ></v-textarea>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            rounded
            @click="removePj=false"
          >
            キャンセル
          </v-btn>
          <v-btn
            class="deepLava white--text px-6"
            rounded
            @click="checkRemovePj=true"
          >
            次へ
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--プロジェクト終了最終確認画面-->
    <v-dialog v-model="checkRemovePj" height="90%" width="80%" class="z1000">
      <v-card
        class="pa-4"
      >
        <p class="text-center pt-8 ma-2 pa-2 font-weight-bold text-h5">
          本当に{{$t('プロジェクト')}}を終了しますか？
        </p>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-chip class="ma-2 pa-4 font-weight-bold" @click="checkRemovePj = false">終了しない</v-chip>
          <v-chip class="ma-2 pa-4 font-weight-bold deepLava" @click="checkRemovePj = false,deletePj()" dark>終了する</v-chip>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--プロジェクト終了通知画面-->
    <v-dialog v-model="noticePjFin" width="60%" class="z1000">
      <v-card class="pt-4 pb-2">
        <v-card-text class="text-center px-8 py-2 text-h5 font-weight-bold" style="color:#0F0101;">この{{$t('プロジェクト')}}は終了しました</v-card-text>
        <v-card-text class="text-center px-8 py-2 text-h5 font-weight-bold" style="color:#0F0101;">ページを再読み込みします</v-card-text>
        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-chip class="mt-4 mx-2 px-4 deepAqua" @click="noticePjFin=false,reload()" dark>確認</v-chip>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--サインイン画面-->
    <v-dialog v-model="authModal" width="400px" height="60%" class="z1000">
      <auth-view
        v-if="authModal"
        defaultView="chooseauth"
        @closeModal="closeAuthModal"
      >
      </auth-view>
    </v-dialog>

    <!--プロフィール画面-->
    <profile_display
      :profile="profile"
      :profuid="profileUid"
      :device="$mq"
      @closeProfile="profile=false"
    ></profile_display>
  </v-card>
  </template>
  
  <script>
  import firebase from "firebase/app"
  import listAdm from '../listAdm.vue'
  import QuoteBlock from '../../components/idea/QuoteBlock.vue'
  import authView from '../../components/auth/authView.vue';
  import profile_display from "../../components/profile/profile_display.vue"
  import "firebase/firestore"
  import Vue from 'vue'
  import VueMq from 'vue-mq'
  Vue.use(VueMq, {
    breakpoints: { // default breakpoints - customize this
      sp: 959,
      pc: 960
    },
    defaultBreakpoint: 'pc' // customize this for SSR
  })

  export default{
    components:{
      listAdm,
      QuoteBlock,
      authView,
      profile_display
    },
    mounted(){
      this.db = firebase.firestore() // dbインスタンスを初期化
      this.today()
      this.setProject_noticeOpen(this.$store.state.config.setting?.project_noticeOpen)
    },
    props:{
      pjuid: String,
      aboutpj: Object,
    },
    data: (vm) => ({
      db: null,
      offsetTop: 0,
      timeday: null,
      currentUid: "",
  
      editNotice: false,
      noticeContent: "",

      checkIdea: false,
      selectedIdea: [],
      idea:[],
      aideauids:[],
      ideaFontSize: "18px",
      links:[],

      lidAdmview:false,
      redis: false,
      noticeRedis: false,
      ProFinCheck: false,
      noticePjFin: false,
      project_noticeOpen: 1,

      authModal: false,
      project_aboutt: 1,

      removeReason: "",
      checkRemovePj: false,
      removePj: false,
      confirmVoteEnd: false,

      profile: false,
      profileUid: "",
    }),
    computed:{
      uid() {
        return this.$store.state.auth?.user?.uid || '';
      },
      config(){
        return this.$store.state.config
      },
      namelist(){
        return this.$store.state.namelist
      },
      profImageDict(){
        return this.$store.state.profImageDict
      },
      pjadmins(){
        return this.$store.state.pjadmins
      },
      isAdmin() {
        return this.$store.state.isAdmin;
      },
      lid(){
        return this.$store.state.lid
      },
      alid(){
        return this.$store.state.alid
      },
      aboutLid() {
        if (this.$store.state.lid.some((u) => u.id === this.$route.params.id)) {
          return this.$store.state.lid.filter((u) => u.id === this.$route.params.id)[0]
        } else if (this.$store.state.alid.some((u) => u.id === this.$route.params.id)) {
          return this.$store.state.alid.filter((u) => u.id === this.$route.params.id)[0]
        } else {
          return null
        }
      },
      isAuthed() {
        return this.$store.state.auth?.isAuthed;
      },
    },
    methods: {
      setProject_noticeOpen(val){
        let value = val
        console.log("setProject_noticeOpen",val)
        if(this.$store.state.config&&this.$store.state.config.setting&&this.$store.state.config.setting.project_noticeOpen) value = this.$store.state.config.setting.project_noticeOpen
        if(!this.aboutpj?.notice?.length)value=false
        this.project_noticeOpen = value
      },
      getIdea(){ //アイデア取得
        console.log()
        let self = this, oneidea = {}
        if(this.idea.length===0){
          this.idea = []
          let collection = this.db.collection("0").doc(this.$route.params.id).collection("idea").where("isActive", "==", true).where("isHidden", "==", false).orderBy('sort', 'asc')
          collection.get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              //console.log(`${doc.id} => ${doc.data()}`)
              oneidea = doc.data()
              self.$set(oneidea,"id",doc.id)
              self.idea.push(oneidea)
            })
            self.idea = self.idea.slice().reverse()
            self.aboutpj.basedIdeas.forEach((el)=>{
              let index = this.idea.filter(oneidea => oneidea.sort == el)[0]
              this.selectedIdea.push(index)
            })
            this.currentUid = this.aboutpj.uid
            //console.log("このprojectのアイデアidea",this.aboutpj.title,this.selectedIdea,this.idea)
          })
          if(this.isAuthed){
            let collection2 = this.db.collection("0").doc(this.$route.params.id).collection("liduser").doc(self.uid).collection("aidea")
            collection2.get().then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                //console.log(`${doc.id} => ${doc.data()}`)
                self.aideauids = doc.data().aideas || []
              })
            })         
          }          
        }
        else if(this.currentUid !== this.aboutpj.uid){
          this.currentUid = this.aboutpj.uid
          this.selectedIdea = []
          self.aboutpj.basedIdeas.forEach((el)=>{
            let index = this.idea.filter(oneidea => oneidea.sort == el)[0]
            this.selectedIdea.push(index)
          })          
          console.log("このprojectのアイデアselect",this.aboutpj.title,this.selectedIdea,this.idea)
        }
      },
      //初期読込関数
      minusone(num){
        return Math.round(num - 1)
      },
      submitNotice(){
        let self = this
        if(this.noticeContent.length >= 1){
          this.aboutpj.notice = this.noticeContent
          //console.log("this.noticeContent"+this.noticeContent)
          this.db.collection("0").doc(this.$route.params.id).collection("project").doc(this.pjuid).update({
            notice: self.noticeContent,
          })
          this.editNotice = false
        }
      },
      //プロジェク状態変更関係関数
      reload(){
        this.$router.go({path: this.$router.currentRoute.path, force: true})
      },
      rePj(){
        this.db.collection("0").doc(this.$route.params.id).collection("project").doc(this.pjuid).update({
          condition: "dis",
          isStartVote: false,
          updatedAt: firebase.firestore.FieldValue.serverTimestamp()
        })
        this.noticeRedis = true
      },
      //プロジェク状態変更関係関数
      endPj(){
        this.db.collection("0").doc(this.$route.params.id).collection("project").doc(this.pjuid).update({
          updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
          isActive: false,
          removeReason: "プロジェクト終了ボタンを押下"
        })
      },
      deletePj(){
        let self = this
        this.db.collection("0").doc(this.$route.params.id).collection("project").doc(this.pjuid).update({
          isActive:false,
          becauseRemove:this.removeReason,
          updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        }).then(function(docRef) {
          // 保存に成功した時
          //console.log("Document written with ID: ", docRef.id)
          self.removeReason = ""
          self.checkRemovePj = false
          self.removePj = false
          self.noticePjFin = true
        }).catch(function(error) {
          // 保存に失敗した時
          console.error("Error adding document: ", error)
        })
      },
      oneaddAdmin(el){
        this.lidAdmview = el
      },
      toDoubleDigits(num) {
          num += "";
          if (num.length === 1) {
            num = "0" + num;
          }
        return num; 
      },
      today(){
        // 日付をYYYY/MM/DD HH:DD:MI:SS形式で取得
        let date = new Date();
        let yyyy = date.getFullYear();
        let mm = this.toDoubleDigits(date.getMonth() + 1)
        let dd = this.toDoubleDigits(date.getDate())
        let hh = this.toDoubleDigits(date.getHours())
        let mi = this.toDoubleDigits(date.getMinutes())
        let se = this.toDoubleDigits(date.getSeconds())
        let ms = this.toDoubleDigits(date.getMilliseconds())
        //this.todayy = yyyy + mm + dd + hh + mi + se + ms
        this.timeday= mm+"/"+dd
        //this.timehour= hh+":"+mi
      },
      closeAuthModal() {
        this.authModal = false
      },
    }
  }
  </script>
  
  <style scoped>
  *{
    font-family:mplus-2c-medium !important;
  }
  ::-webkit-scrollbar {
    display: none;
  }
  /*
  ::-webkit-scrollbar-track {
  background-color: rgba(120, 170, 210,0.3);
  border-radius: 100px;
  }
  ::-webkit-scrollbar-thumb {
  background: #78aad2;
  border-radius: 100px;
  width: 130px;
  }
  */
  </style>